import { apiClient } from "./client";

export interface ClientForecast {
  hour: number;
  client_code: string;
  forecast_kwh: number | string;
}

export interface BaselineForecast {
  client_code: string;
  source: string; // 'avg_4dow' | 'empty'
  by_hour: Record<string, number | string>; // hour-as-string → kWh
}

export const forecastsApi = {
  list: (date: string) =>
    apiClient.get<ClientForecast[]>(`/forecasts/${date}`).then((r) => r.data),

  baseline: (date: string, client_code: string, n_weeks: number = 4) =>
    apiClient
      .get<BaselineForecast>(`/forecasts/${date}/baseline`, {
        params: { client_code, n_weeks },
      })
      .then((r) => r.data),

  put: (date: string, hour: number, client_code: string, forecast_kwh: number) =>
    apiClient
      .put<ClientForecast>(`/forecasts/${date}/hour/${hour}/${client_code}`, {
        forecast_kwh,
      })
      .then((r) => r.data),

  delete: (date: string, hour: number, client_code: string) =>
    apiClient.delete(`/forecasts/${date}/hour/${hour}/${client_code}`),
};
